import React from 'react';
import { styled, Button } from '@teko/ui';

const ColumnTitle = styled.div `
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = styled(Button)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? '72px' : 'initial'};
  justify-content: flex-start;
`);
const ContactInnerLine = styled.div `
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled.img((props) => `
  ${props.isLogo ? 'max-width: 180px;' : ''}
  width: 100%;
`);
const FooterBlock = ({ title, links = [], emails = [], phones = [], flexDir = 'row', image, isLogoImage, btnBlock = true, }) => {
    return (React.createElement(React.Fragment, null,
        title && React.createElement(ColumnTitle, { key: title }, title),
        emails.map((email, index) => {
            return (React.createElement(ContactInnerLine, { key: `email-${index}`, dangerouslySetInnerHTML: {
                    __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`,
                } }));
        }),
        phones.map((phone, index) => {
            return (React.createElement(ContactInnerLine, { key: `email-${index}`, dangerouslySetInnerHTML: {
                    __html: `${phone.children}<a href='tel:${phone.number.replace(/\./g, '')}'}>${phone.number}</a>`,
                } }));
        }),
        links.map((link, index) => {
            return (React.createElement(StyledButton, Object.assign({ tag: "a", block: btnBlock, link: true, key: `link-${index}`, flexDirection: flexDir }, link)));
        }),
        image && React.createElement(StyledImg, { isLogo: !!isLogoImage, src: image, alt: "" })));
};

export { FooterBlock };
